<template>
  <div id="app" v-cloak>
    <router-view />
  </div>
</template>
<script>
import { mapActions, mapState, mapGetters } from "vuex";
import { modules, store } from "./store";
import cardReaderUtil from '@/components/cardUtil/cardReaderUtil'
export default {
  cardReaderUtil: cardReaderUtil,
  data() {
    return {};
  },
  watch: {
    companyList() {
      if (!this.companyList.isQlwVersion && store.state.inQlw) {
        this.selectB({
          isqlw: true,
        });
      } else if (this.companyList.isQlwVersion == null) {
        this.selectB({
          isqlw: false,
        });
      }
    },
    loginUser() {
      //判断是否无权限
      if (this.loginUser.permissions == null) {
        console.log(1118989);
        this.$router.push({
          path: "noPermissions",
        });
      }
    },
    authorizedInfo() {
      console.log(this.authorizedInfo, 'authorizedInfo');
      if(!this.authorizedInfo){
        console.log("你没权限你没权限你没权限你没权限你没权限你没权限");
        this.$router.push({
          path: "unauthorized"
        });
      }
    }
  },
  methods: {
    ...mapActions(modules.user, ["selectB"]),
  },

  computed: {
    ...mapState(["loginUser", "companyList", "authorizedInfo"]),
  },
  created() {
    var sBrowser,
      sUsrAg = navigator.userAgent;
    var advice = ",建议使用谷歌浏览器或者360极速模式获得最佳效果！";
    if (sUsrAg.indexOf("Trident") > -1) {
      sBrowser = "IE";
      alert("暂不支持在" + sBrowser + "浏览器中运行" + advice);
      window.open("", "_top");
      window.top.close();
      window.location.href = "about:blank ";
    }

    // window.close();
  },
};
</script>

<style lang="stylus" scoped>
[v-cloak]
  display: none;
</style>
